// AOS animations
// =============================================
import AOS from 'aos';

(function($) {
  'use strict';

  // Debounce
  // =============================================
  function debounce(func, wait, immediate) {
    let timeout;
    return function() {
      let context = this,
          args = arguments;
      let later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  }


  // Equal heights
  // =============================================
  window.initHeights = function() {

    $(".js-card--nested-tiles").matchHeight({
      byRow: false,
    });
    $(".js-card--related-case-studies").matchHeight({
      byRow: false,
    });
    $(".js-card--featured-insights").matchHeight({
      byRow: false,
    });
    $(".js-card--default").matchHeight({
      byRow: false,
    });
    $(".js-if--content").matchHeight({
      byRow: false,
    });
    $(".js-if--lists").matchHeight({
      byRow: false,
    });
    $(".js-card--horizontal--cs-doc-column").matchHeight({
      byRow: false,
    });
    $(".js-card--heading").matchHeight({
      byRow: false,
    });
    $(".js-slider--events-card-heading").matchHeight({
      byRow: false,
    });
    $(".js-slider--events-card-body").matchHeight({
      byRow: false,
    });
  };

  window.initHeights();
  $(window).on('resize', Drupal.debounce(window.initHeights, 250));

  // Update Insight cards body height on ajax complete
  $(document).ajaxComplete(()=>{
    $.fn.matchHeight._apply('.js-card--featured-insights');
  })


  // Bootstrap tabs history
  // =============================================
  $.fn.historyTabs = function() {
    var that = this;
    window.addEventListener('popstate', function(event) {
      if (event.state) {
        $(that).filter('[href="' + event.state.url + '"]').tab('show');
      }
    });
    return this.each(function(index, element) {
      $(element).on('show.bs.tab', function() {
        var stateObject = {'url' : $(this).attr('href')};

        if (window.location.hash && stateObject.url !== window.location.hash) {
          window.history.pushState(stateObject, document.title, window.location.pathname + $(this).attr('href'));
        } else {
          window.history.replaceState(stateObject, document.title, window.location.pathname + $(this).attr('href'));
        }
      });
      if (!window.location.hash && $(element).is('.active')) {
        // Shows the first element if there are no query parameters.
        $(element).tab('show');
      } else if ($(this).attr('href') === window.location.hash) {
        $(element).tab('show');
      }
    });
  };

  $(".block-inline-blocktabs-contact-us a[data-toggle=tab]").historyTabs();

  // Resources - if url contains string, add class to <a>
  // =============================================
  if ( window.location.href.indexOf("/resources/press-releases-news/") > -1 ) {
    $(".nav-side-item").find("a").removeClass('is-active');
    $(".nav-side-item").find("[title='Press Releases & News']").addClass('is-active');
  }
  if ( window.location.href.indexOf("/resources/documents/") > -1 ) {
    $(".nav-side-item").find("a").removeClass('is-active');
    $(".nav-side-item").find("[title='Documents']").addClass('is-active');
  }

  if ( window.location.href.indexOf("/resources/insights/") > -1 ) {
    $(".nav-side-item").find("a").removeClass('is-active');
    $(".nav-side-item").find("[title='Insights']").addClass('is-active');
  }

  if ( window.location.href.indexOf("/resources/case-studies/") > -1 ) {
    $(".nav-side-item").find("a").removeClass('is-active');
    $(".nav-side-item").find("[title='Case Studies']").addClass('is-active');
  }

  // Re-init AOS after AJAX request with filters (e.g. Case Studies, Insights) to prevent invisible markup
  $(window).ajaxComplete(function(){
    AOS.init({
      delay: 300,
      duration: 500,
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      once: true,
      disable: 'mobile'
    });
  });

})(jQuery);


AOS.init({
  delay: 300,
  duration: 500,
  easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  once: true,
  disable: 'mobile'
});

window.addEventListener('load', AOS.refresh);
window.addEventListener('beforeprint', AOS.destroy);

/*
function wrapRegSymbol() {
  const elements = document.body.querySelectorAll('*'); // Select all elements

  elements.forEach(element => {
    element.innerHTML = element.innerHTML.replace(/®/g, '<sup>&reg;</sup>');
  });
}

function removeSupTagForRegisteredTrademark() {
  const elementsWithSup = document.body.querySelectorAll('sup'); // Only inside <body>

  elementsWithSup.forEach(supElement => {
    if (supElement.textContent === '®' || supElement.innerHTML === '&reg;') {
      const parent = supElement.parentNode;

      if (parent) {
        parent.innerHTML = parent.innerHTML.replace(/<sup>.*?<\/sup>/g, '®');
      }
    }
  });
}

// Call the function after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  removeSupTagForRegisteredTrademark();
  wrapRegSymbol();
});*/